import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

/**
 * Get JWT token from localStorage
 */
const getAuthToken = () => {
    if (typeof window === "undefined") return null;
    try {
        return localStorage.getItem("access_token");
    } catch (err) {
        console.warn("Failed to read token:", err);
        return null;
    }
};

/**
 * Socket instance
 */
export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ["websocket"],
});

// console.log(socket)

/**
 * Connect socket with auth
 */
export const connectSocket = () => {
    const token = getAuthToken();
    if (!token) {
        console.warn("Socket not connected: missing token");
        return;
    }

    socket.auth = { token };
    // console.log(socket.auth)

    if (!socket.connected) {
        socket.connect();
    }
};

/**
 * Disconnect socket safely
 */
export const disconnectSocket = () => {
    if (socket.connected) {
        socket.disconnect();
    }
};

/**
 * Listeners
 */
socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id);
});

socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
});

socket.on("disconnect", (reason) => {
    console.log("🔌 Socket disconnected:", reason);
});
